import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import type { SpecificationStreamContent } from '../types/specification';
import type { EmbodimentOutline } from './create-embodiment-outline-api';

export interface GenEmbodimentRequest {
    task_id: string;
    /** 操作类型 */
    operate_type?: string;
}

export type GenEmbodimentResponse = {
    embodiments: {
        text: string;
        selected: boolean;
    }[]
};

export interface GenEmbodimentFromOutlineRequest extends Partial<EmbodimentOutline> {
    /** 任务ID */
    task_id: string;
    /** 操作类型 */
    operate_type?: string;
    /** 实施例编号 */
    embodiment_number: number;
}

export interface SaveEmbodimentFromOutlineRequest {
    task_id: string;
    embodiment_number: number;
    type: string;
    claim_numbers: number[];
    text: string;
}

export type SaveEmbodimentFromOutlineResponse = {
    embodiment_number: number;
    task_id: string;
    type: string;
    claim_numbers: number[];
    text: string;
}

export interface DeleteEmbodimentWithOutlineRequest {
    task_id: string;
    embodiment_number: number;
}

export type DeleteEmbodimentWithOutlineResponse = {
    // 接口返回内容不关心，可以定义为空对象
}

export const GenEmbodimentApi = Symbol.for('GenEmbodimentApi');

export interface GenEmbodimentApi {
    genEmbodiment(data: GenEmbodimentRequest): PsHttpSSE<SpecificationStreamContent<GenEmbodimentResponse>>;

    genEmbodimentFromOutline(data: GenEmbodimentFromOutlineRequest): PsHttpSSE<SpecificationStreamContent<string>>;

    saveEmbodimentFromOutline(data: SaveEmbodimentFromOutlineRequest): Promise<SaveEmbodimentFromOutlineResponse>;

    deleteEmbodimentWithOutline(data: DeleteEmbodimentWithOutlineRequest): Promise<DeleteEmbodimentWithOutlineResponse>;
}
